import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

export class StatsCard extends Component {
  render() {
    //console.log(this.props.statsValue);
    return (
      <div className="card card-stats">
        <div className="content">
          <Row>
            <Col xs={2}>
              <div className="icon-big text-center icon-warning">
                {this.props.bigIcon}
              </div>
            </Col>
            <Col xs={10}>
              <div className="numbers ">
                <p>{this.props.statsText}</p>
                {this.props.statsValue.map((value, key) => {
                  return <div key={key}>{value}</div>;
                })}
              </div>
            </Col>
          </Row>
          <div className="footer">
            <hr />
            <div className="stats">
              {this.props.statsIcon} {this.props.statsIconText}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StatsCard;



// WEBPACK FOOTER //
// ./src/components/StatsCard/StatsCard.jsx